<template>
  <div style="display: inline-block">
    <button
      v-for="m of months"
      :key="m"
      :class="{ 'btn': true, 'text-danger': m === value, 'border-danger': m === value }"
      :disabled="disabled(m)"
      @click.prevent="$emit('input', m)"
      v-text="getMonthFormated(m)"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { capitalizeFirstLetter } from '../../../../../../../resources/js/helper'

export default {
  name: 'MonthSelect',
  props: {
    value: {
      type: Number,
      required: true
    },
    year: {
      type: Number,
      required: true
    }
  },
  computed: {
    months () {
      const months = []

      for (
        let m = moment().startOf('year');
        m.diff(moment().endOf('year'), 'days') < 0;
        m.add(1, 'months')
      ) {
        months.push(m.month())
      }

      return months
    }
  },
  methods: {
    disabled (month) {
      return moment().isSame(moment().year(this.year)) && moment().month(month).startOf('month').diff(moment().startOf('month'), 'days') > 0
    },
    getMonthFormated: month => capitalizeFirstLetter(moment().month(month).format('MMMM'))
  }
}
</script>

<style lang="scss" scoped>
.btn {
  background: transparent;
}
</style>
